import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import classNames from "classnames"
import memo from "set-state-compare/src/memo"
import Nav from "components/nav"
import NavItem from "components/nav/item"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import {Subscription} from "models"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"

export default memo(shapeComponent(class ComponentsAdminSubscriptionsNav extends ShapeComponent {
  static propTypes = {
    active: PropTypes.string,
    className: PropTypes.string,
    subscription: PropTypes.instanceOf(Subscription).isRequired
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.admin.subscriptions.nav"})

    this.setInstance({t})
  }

  render() {
    const {t} = this.tt
    const {active, className, subscription, ...restProps} = this.props

    return (
      <Nav className={classNames("components--admin--subscriptions--nav", className)} {...restProps}>
        <NavItem active={active} identifier="general" label={t("js.shared.general")} to={Routes.adminSubscriptionPath(subscription.id())} />
        <NavItem
          active={active}
          identifier="periods"
          label={`${Subscription.humanAttributeName("subscriptionPeriods")} (${subscription.subscriptionPeriodsCount()})`}
          to={Routes.periodsAdminSubscriptionPath(subscription.id())}
        />
      </Nav>
    )
  }
}))
